export const   inviteFriendsImageUrls = {
    award_pc_1: "https://pstatic.navi-sci.cn/inviteActivity/award_pc_1.png",
    award_pc_2: "https://pstatic.navi-sci.cn/inviteActivity/award_pc_2.png",
    award_pc_3: "https://pstatic.navi-sci.cn/inviteActivity/award_pc_3.png",
    invite_f_1: "https://pstatic.navi-sci.cn/inviteActivity/invite_f_1.png",
    invite_f_2: "https://pstatic.navi-sci.cn/inviteActivity/invite_f_2.png",
    invite_f_3: "https://pstatic.navi-sci.cn/inviteActivity/invite_f_3.png",
    join_1: "https://pstatic.navi-sci.cn/inviteActivity/join_1.png",
    join_2: "https://pstatic.navi-sci.cn/inviteActivity/join_2.png",
    withdraw_pc_bg: "https://pstatic.navi-sci.cn/inviteActivity/withdraw_pc_bg.png",
    wxQrcode:"https://pstatic.navi-sci.cn/inviteActivity/qrcode_for_gh_62e22cd1f397_1280.jpg"
}